import script from "./SimulateDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./SimulateDialog.vue?vue&type=script&lang=ts&setup=true"

import "./SimulateDialog.vue?vue&type=style&index=0&id=07378656&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07378656"]])

export default __exports__